import { render, staticRenderFns } from "./RequestMatchingArchivesIssuesControls.vue?vue&type=template&id=8cd8ab24&v-else=true&"
import script from "./RequestMatchingArchivesIssuesControls.vue?vue&type=script&lang=js&"
export * from "./RequestMatchingArchivesIssuesControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
